"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3.17 15.17L0 12l4.93-4.93A9.977 9.977 0 0114 4.35L3.17 15.17zM24 12l-4.93 4.93c-3.29 3.29-8.3 3.8-12.13 1.54L3.7 21.71 2.29 20.3l3.02-3.02 3.25-3.25 5.45-5.45 3.04-3.04 3.23-3.23 1.41 1.41-3.02 3.02c.13.11.27.22.39.34L24 12zm-8 0c0-.74-.21-1.43-.56-2.03l-5.47 5.47c.6.35 1.29.56 2.03.56 2.21 0 4-1.79 4-4z" }), "Hide");
//# sourceMappingURL=Hide.js.map